import React from "react";
import { FieldPath, FieldValues, UseControllerProps, useController } from "react-hook-form";


type Props = {
  name: string;
  id: string;
  value: string;
  label: string;
  isActive: boolean;
  checked: boolean;
  disabled?: boolean;
  onChange: (e) => void;
}

function Radio<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
  >({ disabled = false, ...props }: UseControllerProps<TFieldValues, TName> & Props) {
  
  const {
    field
  } = useController(props);

  return (
    <div className="flex">
      <input
        {...field}
        checked={props.checked}
        name={props.name}
        value={props.value}
        id={props.id}
        disabled={disabled}
        onChange={(e) => {
          field.onChange(e);
          props.onChange(e);
        }}
        type="radio"
        className={`${props.isActive ? "border-[#B1C2CC]" : "border-[#006AC9] border-2"} radio-btn mr-[10px] h-5 w-5 shrink-0 rounded-[50%] border relative appearance-none`}
      />
      <label htmlFor={props.id}>{props.label}</label>
    </div>
  );
}

export default Radio;
